import axios from "axios";

export const apiKey = window.RUNTIME_API_URL;

export const logoutOn401 = (error) => {
  const status = error?.response?.status;
  const status_code = error?.response?.data?.status_code;

  if (status === 401 || status_code === 401 || status === 403 || status_code === 403) {
    const pathname = window.location.pathname.replace(/\/$/, "");
    if (pathname === "/admin" || pathname === "") {
      return false;
    }

    sessionStorage.removeItem("aman-admin");

    if (window.location.pathname.startsWith("/admin")|| window.location.pathname.startsWith("/POS")) {
      window.location.href = "/admin";
    } else {
      window.location.href = "/";
    }
    return true;
  }
  return false;
};

// Automatically intercept axios responses to handle 401 errors globally
axios.interceptors.response.use(
  (response) => response,
  (error) => {
    logoutOn401(error);
    return Promise.reject(error);
  }
);